import * as React from 'react';
import { HoverCard as HoverCardPrimitive } from 'radix-ui';

import { cn } from '../../lib/utils';
import { POPOVER_VIEWPORT_MAX_WIDTH_CLASS } from './popover';

function HoverCard({ ...props }: React.ComponentProps<typeof HoverCardPrimitive.Root>) {
  return <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
}

function HoverCardTrigger({ ...props }: React.ComponentProps<typeof HoverCardPrimitive.Trigger>) {
  return <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
}

function HoverCardContent({
  className,
  align = 'center',
  sideOffset = 4,
  'aria-label': ariaLabel = 'Preview',
  container,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content> & {
  container?: React.ComponentProps<typeof HoverCardPrimitive.Portal>['container'];
}) {
  return (
    <HoverCardPrimitive.Portal container={container}>
      <HoverCardPrimitive.Content
        data-slot="hover-card-content"
        data-lenis-prevent
        align={align}
        sideOffset={sideOffset}
        aria-label={ariaLabel}
        className={cn(
          'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-80 min-w-0 origin-[--radix-hover-card-content-transform-origin] overflow-x-hidden rounded-md border p-4 shadow-md outline-hidden',
          POPOVER_VIEWPORT_MAX_WIDTH_CLASS,
          'max-h-[var(--radix-hover-card-content-available-height)]',
          className,
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
}

export { HoverCard, HoverCardTrigger, HoverCardContent };
